export default interface Cube
{
  id: string;
  name: string;
  averagePlayTimeSeconds: number;
  gameType: GameType;
  numberOfPlayers: NumberOfPlayers,
  journeyPhases: JourneyPhase[],
  difficultyTypes: DifficultyType[],
  lengthOfGame: LengthOfGame,
  isBulletTime: boolean,
  maintenanceMode: boolean;
}

export enum GameType
{
  Floor = "Floor",
  Timed = "Timed",
  ThrowCatch = "ThrowCatch",
  SteadyHand = "SteadyHand",
  Judgement = "Judgement",
  Blindfold = "Blindfold",
}

export enum NumberOfPlayers
{
  One = "One",
  Two = "Two",
}

export enum JourneyPhase
{
  Start = "Start",
  Middle = "Middle",
  End = "End",
}

export enum DifficultyType
{
  Band1 = "Band1",
  Band2 = "Band2",
  FinalGame = "FinalGame",
}

export enum LengthOfGame
{
  Quick = "Quick",
  Medium = "Medium",
  Slow = "Slow",
}